import { Grid, TextField } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";

interface Values {
  executorFirstName: string;
  executorMiddleName: string;
  executorLastName: string;
}

interface Props {
  role: string;
  screenData?: Record<string, string | number | boolean>[];
}

export const BizExecutorName = ({ role, screenData }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  console.log(`${currentScreen} screenData: ${JSON.stringify(screenData)}`);

  const executorFirstName =
    (screenData?.length && (screenData[0]?.executorFirstName as string)) || "";
  const executorMiddleName =
    (screenData?.length && (screenData[0]?.executorMiddleName as string)) || "";
  const executorLastName =
    (screenData?.length && (screenData[0]?.executorLastName as string)) || "";

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      executorFirstName,
      executorMiddleName,
      executorLastName,
    },
    schema: Yup.object().shape({
      executorFirstName: Yup.string().required(),
      executorMiddleName: Yup.string(),
      executorLastName: Yup.string().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database
      console.log(`save name to ${role} (executive or attorney) field`);

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="What is the name of the executor?"
      subTitle="This is the person who has been legally named to settle the estate and to distribute any applicable assets in the estate."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={1}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <TextField
                  error={Boolean(
                    touched.executorFirstName && errors.executorFirstName
                  )}
                  fullWidth
                  helperText={
                    touched.executorFirstName && errors.executorFirstName
                  }
                  label="First name"
                  margin="normal"
                  name="executorFirstName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.executorFirstName}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(
                    touched.executorMiddleName && errors.executorMiddleName
                  )}
                  fullWidth
                  helperText={
                    touched.executorMiddleName && errors.executorMiddleName
                  }
                  label="Middle name"
                  margin="normal"
                  name="executorMiddleName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.executorMiddleName}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(
                    touched.executorLastName && errors.executorLastName
                  )}
                  fullWidth
                  helperText={
                    touched.executorLastName && errors.executorLastName
                  }
                  label="Last name"
                  margin="normal"
                  name="executorLastName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.executorLastName}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
